import { Avatar, Box, Typography } from "@mui/material";

import java from "./assets/techStackIcons/java.png";
import python from "./assets/techStackIcons/python.png";
import pytorch from "./assets/techStackIcons/pytorch.jpeg";
import opencv from "./assets/techStackIcons/opencv.png";
import numpy from "./assets/techStackIcons/numpy.png";
import matplotlib from "./assets/techStackIcons/matplotlib.png";
import golang from "./assets/techStackIcons/golang.png";
import adobe from "./assets/techStackIcons/adobe.png";
import agile from "./assets/techStackIcons/agile.png";
import aws from "./assets/techStackIcons/aws.png";
import distcomp from "./assets/techStackIcons/distcomp.png";
import django from "./assets/techStackIcons/django.png";
import docker from "./assets/techStackIcons/docker.png";
import git from "./assets/techStackIcons/git.png";
import github from "./assets/techStackIcons/github.png";
import html from "./assets/techStackIcons/html.png";
import jest from "./assets/techStackIcons/jest.png";
import js from "./assets/techStackIcons/js.png";
import kotlin from "./assets/techStackIcons/kotlin.png";
import linux from "./assets/techStackIcons/linux.png";
import maven from "./assets/techStackIcons/maven.png";
import mspp from "./assets/techStackIcons/mspp.png";
import mysql from "./assets/techStackIcons/mysql.png";
import parallelcomp from "./assets/techStackIcons/parallelcomp.png";
import reactjs from "./assets/techStackIcons/reactjs.png";
import springboot from "./assets/techStackIcons/springboot.png";
import teaching from "./assets/techStackIcons/teaching.png";
import vuejs from "./assets/techStackIcons/vuejs.png";
import windows from "./assets/techStackIcons/windows.png";
import c from "./assets/techStackIcons/c.png"

const IconPaths = {
  java: { name: "Java", path: java },
  python: { name: "Python", path: python },
  pytorch: { name: "PyTorch", path: pytorch },
  opencv: { name: "OpenCV", path: opencv },
  numpy: { name: "NumPy", path: numpy },
  matplotlib: { name: "matplotlib", path: matplotlib },
  golang: { name: "Go", path: golang },
  adobe: { name: "Adobe software", path: adobe },
  agile: { name: "Agile workflows", path: agile },
  aws: { name: "AWS", path: aws },
  distcomp: { name: "Distributed computing", path: distcomp },
  django: { name: "Django", path: django },
  docker: { name: "Docker", path: docker },
  git: { name: "Git", path: git },
  github: { name: "GitHub", path: github },
  githubwork: { name: "GitHub Workflows", path: github },
  html: { name: "HTML", path: html },
  jest: { name: "Jest", path: jest },
  js: { name: "JavaScript", path: js },
  kotlin: { name: "Kotlin", path: kotlin },
  linux: { name: "Linux", path: linux },
  maven: { name: "Maven", path: maven },
  mspp: { name: "Microsoft Power Platform", path: mspp },
  mysql: { name: "SQL", path: mysql },
  parallelcomp: { name: "Parallel computing", path: parallelcomp },
  reactjs: { name: "React", path: reactjs },
  springboot: { name: "Spring Boot", path: springboot },
  teaching: {
    name: "Teaching (university, secondary and college level)",
    path: teaching,
  },
  vuejs: { name: "Vue.js", path: vuejs },
  windows: { name: "Windows", path: windows },
  c: {name: "C", path: c}
};

function SkillBadge({skill}) {
    let name = IconPaths[skill]["name"]
    let path = IconPaths[skill]["path"]
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 2,
        px: 1.5,
        py: 0.5,
        mx:0.5,
        my:0.5,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: "16px",
        bgcolor: "background.paper",
      }}
    >
      <Avatar
        alt={name}
        src={path}
        variant="square"
        sx={{
          width: 20,
          height: 20,
          bgcolor: "transparent",
          "& img": {
            objectFit: "contain",
            width: "100%",
            height: "100%",
          },
        }}
      />
      <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
        {name}
      </Typography>
    </Box>
  );
}

export default SkillBadge;
export { IconPaths };
